import styled from 'styled-components';

export const StyledSpinnerContainer = styled.div`
  position: absolute;
  z-index: 99;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
